export const API_URLS = {
  login: `/api/v1/admin-login`,
  emp_registration: `/api/v1/employee-registration`,
  emp_registration_update: `/api/v1/employee-update`,
  emp_registration_list: `/api/v1/employee-list`,
  admin_login_as_employee: `/api/v1/login-as-employee`,
  emp_registration_status: `/api/v1/employee-status`,
  lead_source_add: `/api/v1/create-lead-source`,
  lead_source_list: `/api/v1/lead-source-list`,
  lead_source_status: `/api/v1/lead-source-status`,
  lead_src_list_lead_creation: `/api/v1/lead-src-list-lead-creation`,
  lead_contact_method_list: `/api/v1/lead-contact-method-list`,
  basic_lead_list: `/api/v1/basic-lead-list`,
  lead_report_list: `/api/v1/lead-report-list`,
  leads_by_followup_type: `/api/v1/leads-by-followup-type`,
  lead_followups_list_admin: `/api/v1/get-lead-followups-list`,
  basic_lead_bucket_count: `/api/v1/basic-lead-bucket-count`,
  followup_type_bucket_count: `/api/v1/followup-type-bucket-count`,
  followup_types: `/api/v1/follow-up-types`,
  unassigned_lead_list: `/api/v1/unassigned-lead-list`,
  assign_lead_to_employee: `/api/v1/assign-lead-to-employee`,
  lead_list_for_transfer: `/api/v1/lead-list-for-transfer`,
  transfer_lead_to_employee: `/api/v1/transfer-lead-to-employee`,
  create_lead_list_by_admin: `/api/v1/create-lead-list-by-admin`,
  create_lead_list_by_admin_excel: `/api/v1/create-lead-list-by-admin-excel`,
  claimed_list_data_admin: `/api/v1/claimed-list-data-admin`,
  add_project_details: `/api/v1/add-project-details`,
  project_details: `/api/v1/project-details-list`,
  add_phase_details: `/api/v1/add-phase-details`,
  project_phase_details_by_id: `/api/v1/project-phase-details-by-id`,
  update_project_details: `/api/v1/update-project-details`,
  update_phase_details: `/api/v1/update-project-phases-details`,
  update_phase_status: `/api/v1/update-phase-status`,
  admin_count: `/api/v1/dashboard-bucket-count`,
  project_list_dropdown: `/api/v1/project-list-dropdown`,
  add_failedtitle: `/api/v1/add_failed_title  `,
  lead_profile: `/api/v1/lead-profile`,
  employee_profile: `/api/v1/get-employee-profile-by-admin`,
  channel_partner: `/api/v1/channel-partner-list`,
  get_failed_list: `/api/v1/get_failed_list`,
  get_lead_note_list: `/api/v1/get-lead-note-list`,
  get_employee_list: `/api/v1/get-employee-status-list`,
  get_allemployee_data: `/api/v1/get-all-emp-data`,
  get_all_emp_list: `/api/v1/get-all-emp-data`,
  get_emp_list_lead: `/api/v1/get-bucket-wise-lead-list-by-emp-id`,
  call_logs_admin: `/api/v1/call-logs-admin`,
  employee_list_dropdown: `/api/v1/employee-list-dropdown`,


// we
 emp_login: `/api/v1/emp-login`,
  get_dashboard_data_emp: `/api/v1/get-dashboard-data-emp`,
  emp_claimed_lead_list: `/api/v1/claimed-lead`,
  create_lead_by_emp: `/api/v1/create-lead-emp`,
  lead_src_list_lead_creation_emp: `/api/v1/lead-src-list-lead-creation-emp`,
  project_list_dropdown_emp: `/api/v1/project-list-dropdown-emp`,
  add_update_lead_notes_emp: `/api/v1/add-update-lead-notes`,
  get_lead_notes_emp: `/api/v1/get-lead-notes`,
  move_lead_status_emp: `/api/v1/move-to-next-status`,
  add_lead_followup_emp: `/api/v1/add-lead-followup`,
  get_lead_followups_emp: `/api/v1/get-lead-followups`,
  followup_type_bucket_count_emp: `/api/v1/followup-type-bucket-count-emp`,
  followup_types_emp: `/api/v1/follow-up-types-emp`,
  todays_pending_followups_emp: `/api/v1/todays-pending-followups-emp`,
  leads_by_followup_type_emp: `/api/v1/leads-by-followup-type-emp`,
  weekly_lead_trend_emp: `/api/v1/weekly-lead-trend-emp`,
  lead_source_breakdown_emp: `/api/v1/lead-source-breakdown-emp`,


};
